import { HttpClient } from '@angular/common/http';
import { Injectable, forwardRef, inject } from '@angular/core';
import { API_URL } from '@equine-ui-nx/injection-tokens';
import { CreateGLCode, GLCode, UpdateGLCode } from '../interfaces/glCode.interface';
import { Observable } from 'rxjs';

@Injectable()
export class GlCodeService {

  apiUrl = inject(forwardRef(() => API_URL));
  baseUrl = `${this.apiUrl}/glCodes`
  http = inject(HttpClient);  

  create(payload: CreateGLCode): Observable<{id: string}> {
    return this.http.post<{id: string}>(this.baseUrl, payload);
  }

  update(id: string, payload: UpdateGLCode): Observable<any> {
    return this.http.post(`${this.baseUrl}/${id}`, payload);
  }

  delete(id: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/delete/${id}`, {});
  }

  getAll(): Observable<GLCode[]> {
    return this.http.get<GLCode[]>(`${this.baseUrl}`);
  }


}
